import React, { useState } from 'react';

const QUESTIONS = [
  {
    q: 'Muss ich einen MINI besitzen, um mitzumachen?',
    a: 'Nein. Ohne MINI bist du als Gast dabei: Du siehst alle offenen Treffen und kannst mitkommen - als Beifahrerin, mit Kaufplänen oder einfach aus Neugier. Wer einen MINI fährt, wird Mitglied und sieht zusätzlich die internen Termine. Wer regelmäßig dabei ist und mit organisiert, gehört zur Crew.',
  },
  {
    q: 'Wie werde ich Teil der Crew?',
    a: 'Gar nicht auf Antrag - die Crew ergibt sich. Wer regelmäßig bei Treffen auftaucht und bei der Organisation mit anpackt, wird von uns umgestuft. Das ist kein Rang, sondern eine Beschreibung: Diese Leute machen den Club.',
  },
  {
    q: 'Gibt es euch auch in meiner Region?',
    a: 'Gegründet haben wir uns in Bonn/Sieg, aber der Club ist nicht an eine Region gebunden. Jedes Mitglied kann sich als Orga bewerben und in seiner Ecke Ausfahrten und Stammtische anlegen - die Seite schlägt dafür Treffpunkt, Route und Restaurant vor. Und über den Umkreisfilter siehst du nur die Termine, zu denen du auch tatsächlich fahren würdest. Es bleibt dabei ein Club, keine Ortsgruppen.',
  },
  {
    q: 'Was kostet die Mitgliedschaft?',
    a: 'Der Zugang zur Community und die Teilnahme an öffentlichen Treffen kosten nichts. Für die Organisation größerer Veranstaltungen sammeln wir anlassbezogen einen Beitrag ein - immer transparent und vorher angekündigt.',
  },
  {
    q: 'Wie werde ich Mitglied?',
    a: 'Über das Formular auf "Mitglied werden" registrieren. Dort fragen wir, ob du einen MINI fährst - daraus ergibt sich, ob du als Gast oder als Mitglied startest. Wir schauen uns jede Anfrage kurz an und schalten dich dann frei, meist innerhalb von ein bis zwei Tagen.',
  },
  {
    q: 'Warum muss meine Anmeldung freigegeben werden?',
    a: 'Weil wir eine Community von Menschen sind, keine offene Plattform. Die manuelle Freigabe hält Werbe-Accounts draußen und sorgt dafür, dass im internen Bereich wirklich nur die Crew mitliest.',
  },
  {
    q: 'Fahrt ihr auch auf Rennstrecken?',
    a: 'Unsere Ausfahrten sind entspannte Touren auf öffentlichen Straßen - kein Rennen, keine Wettbewerbe. Wer auf die Rennstrecke will, findet bei uns aber garantiert Begleitung.',
  },
  {
    q: 'Seid ihr offiziell von MINI oder BMW?',
    a: 'Nein. Club Mini-Thrills ist ein privates Fan-Projekt ohne Verbindung zur BMW AG oder zu MINI. Wir sind Enthusiasten, keine Vertretung des Herstellers.',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="mt-section" id="faq">
      <div className="mt-container">
        <div className="mt-head mt-head--center">
          <span className="mt-kicker">Häufige Fragen</span>
          <h2>Kurz beantwortet</h2>
        </div>

        <div className="mt-faq">
          {QUESTIONS.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className={`mt-faq__item ${isOpen ? 'is-open' : ''}`}>
                <h3 className="mt-faq__heading">
                  <button
                    type="button"
                    className="mt-faq__trigger"
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                    id={`faq-trigger-${index}`}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    <span>{item.q}</span>
                    <span className="mt-faq__icon" aria-hidden="true">
                      {isOpen ? '−' : '+'}
                    </span>
                  </button>
                </h3>
                <div
                  id={`faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`faq-trigger-${index}`}
                  className="mt-faq__panel"
                  hidden={!isOpen}
                >
                  <p>{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
